export enum TestArea {
  EMBARGO = 'Embargo area',
  PREPROD = 'Pre-Prod area',
  PROD = 'Prod area',
  BASE = 'Base'
}
